import {
  useDeleteWatchTrip,
  type UseDeleteTripWatchTripReturn,
} from "@apac/price-watch";

export type UnwatchTripResponse = unknown;

export interface UseUnwatchTripFormReturn {
  context: UseDeleteTripWatchTripReturn["context"];
  handlers: {
    onUnwatchTripSubmit: () => Promise<unknown>;
  };
}

export const useUnwatchTripForm = ({
  flightKey,
  onSubmit,
  onSuccess,
  onError,
}: {
  flightKey;
  onSubmit?: () => void;
  onSuccess?: (response: UnwatchTripResponse) => unknown;
  onError?: (error: unknown) => unknown;
}): UseUnwatchTripFormReturn => {
  const {
    context,
    handlers: { unwatch },
  } = useDeleteWatchTrip({ flightKey });

  return {
    context,
    handlers: {
      onUnwatchTripSubmit: async () => {
        onSubmit?.();
        try {
          const response = await unwatch();
          await onSuccess?.(response);

          return response;
        } catch (error) {
          console.error("Error in unwatch trip request: ", error);
          onError?.(error);
        }
      },
    },
  };
};
